// extracted by mini-css-extract-plugin
export default {"Error":"_Error--uTITp","Header":"_Header--X5m5V","Paragraph":"_Paragraph--lYwo6","Info":"_Info--vISAH"};